export default "__VITE_ASSET__1a60f49a__"